import { render } from "./ComplaintForm.vue?vue&type=template&id=5e2a6d2b&scoped=true"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"

import "./ComplaintForm.vue?vue&type=style&index=0&id=5e2a6d2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e2a6d2b"

export default script